import { render, staticRenderFns } from "./MoviePlayer.vue?vue&type=template&id=4e596abe&"
import script from "./MoviePlayer.vue?vue&type=script&lang=js&"
export * from "./MoviePlayer.vue?vue&type=script&lang=js&"
import style0 from "./MoviePlayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../var/www/html/film-screening-production/avails/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../var/www/html/film-screening-production/avails/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDivider,VFlex,VLayout})
